/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CharterBlockResource } from './';
import {
    CharterBlockResourceFromJSON,
    CharterBlockResourceFromJSONTyped,
    CharterBlockResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CharterResource
 */
export interface CharterResource {
    /**
     * 
     * @type {boolean}
     * @memberof CharterResource
     */
    hasProfile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CharterResource
     */
    signed: boolean;
    /**
     * 
     * @type {Array<CharterBlockResource>}
     * @memberof CharterResource
     */
    blocks: Array<CharterBlockResource>;
}

/**
 * Check if a given object implements the CharterResource interface.
 */
export function instanceOfCharterResource(value: object): value is CharterResource {
    if (!('hasProfile' in value) || value['hasProfile'] === undefined) return false;
    if (!('signed' in value) || value['signed'] === undefined) return false;
    if (!('blocks' in value) || value['blocks'] === undefined) return false;
    return true;
}

export function CharterResourceFromJSON(json: any): CharterResource {
    return CharterResourceFromJSONTyped(json, false);
}

export function CharterResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharterResource {
    if (json == null) {
        return json;
    }
    return {
        
        'hasProfile': json['hasProfile'],
        'signed': json['signed'],
        'blocks': ((json['blocks'] as Array<any>).map(CharterBlockResourceFromJSON)),
    };
}

export function CharterResourceToJSON(value?: CharterResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hasProfile': value['hasProfile'],
        'signed': value['signed'],
        'blocks': ((value['blocks'] as Array<any>).map((v) => CharterBlockResourceToJSON(v))),
    };
}

